import { createUseStyles } from 'react-jss';

const styles = createUseStyles(theme => {
  const { breakpoints, palette, spacing } = theme;
  return {
    homeContainer: {
      backgroundColor: palette.main,
      minHeight: '1250px',
    },
    bodyContainer: {
      marginTop: `${spacing['5']}px`,
      maxWidth: '1400px',
      margin: 'auto',
    },
    tabletSearchBox: {
      [`@media screen and (min-width: ${breakpoints.md}px)`]: {
        width: '70%',
      },
      [`@media screen and (min-width: ${breakpoints.lg}px)`]: {
        width: '50%',
      },
    },
    featuredApps: {
      [`@media screen and (max-width: 1383px) and (min-width: 1133px)`]: {
        '& .appCardSelector:nth-child(n+4)': {
          display: 'none',
        },
      },
    },
    results: {
      '& button': {
        height: 'auto',
      },
    },
  };
});

export default styles;
